import { useQuery } from 'react-query';

import { getGantActivitiesGraph as queryFn } from 'api/endPoints/getGantActivitiesGraph';

import { IGanttChartPayload, IGanttChartResponse } from 'components/widgets/Gantt/components/ganttChart.types';

export const useQueryGanttChart = (params: IGanttChartPayload | null) => {
    return useQuery<IGanttChartResponse, QueryError>(['ganttChartActivities', params], () => queryFn(params), {
        enabled: Boolean(params?.id) && typeof params?.maxLevel === 'number' && typeof params?.minLevel === 'number',
        placeholderData: {
            activities: [],
            info: {
                infoList: '',
                link: '',
            },
            versionDate: 0,
        },
    });
};
